import { List } from '@/components/SettingsLayout';
import { FINAL_USERS } from '@/enums';
import { useGetUser } from '@/hooks';
import { IconType, SettingsLink } from '@/ui';
import { useParams } from 'react-router-dom';

type Props = {
  baseUrl: string;
  selfSettings?: boolean;
};

const SingleAccountList = ({ baseUrl, selfSettings = false }: Props) => {
  const { id } = useParams();
  const { currentUser } = useGetUser();

  const linkItems = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      path: 'dashboard',
      show: !selfSettings,
    },
    { key: 'profile', label: 'Profile', path: 'profile', show: true },
    { key: 'users', label: 'Users', path: 'users', show: true },
    { key: 'api-keys', label: 'API Keys', path: 'api-keys', show: true },
    FINAL_USERS.includes(currentUser.type)
      ? { key: 'pricing', label: 'Pricing', path: 'pricing', show: true }
      : {},
  ];

  return (
    <List>
      <List.Header>
        <div />
      </List.Header>
      <List.Body>
        {linkItems
          .filter((item) => item.show)
          .map((item) => (
            <li key={item.key}>
              <SettingsLink
                href={`${baseUrl}/${id}/${item.path}`}
                text={item.label || ''}
                svg={IconType.DropDownIcon}
                svgRotate={'-90'}
                testId={`${item.key}-settings-link`}
              />
            </li>
          ))}
      </List.Body>
    </List>
  );
};

export default SingleAccountList;
